module.exports = __webpack_public_path__ + "img/Medium.8856f92a.png";